<template>
  <div>
    <list
      row-key="GoodsId"
      ref="list"
      unit="库存查询"
      :expand-all-row="false"
      :page="page"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="所属商家" v-if="loginInfo.UserType == 0">
          <el-select
            v-model="params.StoreId"
            @change="onChange"
            placeholder="请选择商家"
            filterable
            clearable
          >
            <el-option
              v-for="item in busiList"
              :key="item.RecordId"
              :label="item.BusiName"
              :value="item.RecordId"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="仓库">
          <el-select
            v-model="params.WhId"
            placeholder="请选择入库仓库"
            clearable
            filterable
          >
            <el-option
              v-for="(i, k) in whList"
              :key="k"
              :label="i.WhName"
              :value="i.RecordId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input
            v-model="params.GoodsName"
            placeholder="请输入商品名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="商品类别" v-if="loginInfo.UserType == 1">
          <tree-select
            ref="treeSelectStore"
            :props="props"
            :options="Types"
            :clearable="false"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelectStore($event)"
          />
        </el-form-item>
        <el-form-item label="商品类别" v-if="loginInfo.UserType == 0">
          <tree-select
            ref="treeSelect"
            :props="props"
            :options="TypePlatforms"
            :clearable="true"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input
            v-model="params.AttributeName"
            placeholder="请输入规格型号"
            clearable
          />
        </el-form-item>
        <el-form-item label="库存量" class="num-range">
          <el-input
            v-model="params.AvailableQuantityStart"
            type="number"
            placeholder="请输入库存量"
            clearable
          />
          -
          <el-input
            v-model="params.AvailableQuantityEnd"
            type="number"
            placeholder="请输入库存量"
            clearable
          />
        </el-form-item>
        <el-form-item label="可用量" class="num-range">
          <el-input
            v-model="params.ExistQuantityStart"
            type="number"
            placeholder="请输入可用量"
            clearable
          />
          -
          <el-input
            v-model="params.ExistQuantityEnd"
            type="number"
            placeholder="请输入可用量"
            clearable
          />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column type="expand" width="40">
          <template slot-scope="{ row }">
            <el-table
              :data="row.Inventoryattrgoods"
              v-if="row.Inventoryattrgoods"
              size="mini"
              border
              style="width: 90%; margin: 20px; margin-left: 40px"
            >
              <el-table-column prop="WhName" label="仓库名称" />
              <el-table-column prop="AttributeName" label="规格型号" />
              <el-table-column prop="AttributeCode" label="货号" />
              <el-table-column prop="AvailableQuantity" label="库存量" />
              <el-table-column prop="ExistQuantity" label="可用量" />
            </el-table>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="StoreName"
          label="所属商家"
          v-if="loginInfo.UserType == 0"
        /> -->
        <el-table-column prop="GoodsName" label="商品名称" />
        <el-table-column prop="GoodsCode" label="商品编码" />
        <el-table-column
          prop="TypeNameChain"
          label="类别"
          v-if="loginInfo.UserType == 1"
        />
        <el-table-column prop="TypeplatformNameChain" label="类别" v-else />
        <el-table-column prop="AvailableQuantity" label="库存量" />
        <el-table-column prop="ExistQuantity" label="可用量" />

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import busiSelect from "@/components/shop/business/select";

export default {
  mixins: [listMixin],
  components: { list, busiSelect },
  data() {
    return {
      api: require("@/api/wh/inventory").default,
      api2: require("@/api/shop/business").default,
      api3: require("@/api/wh/base").default,
      typePlatform_api: require("@/api/goods/typeplatform").default,
      type_api: require("@/api/goods/type").default,
      params: {
        //这里只是声明查询条件参数的初始值，不是一定每个参数都需要在这里写，具体还是以为上面v-model="params.WhName" 这种为准。
        GoodsName: "",
        TypeNameLevel1: "",
        TypeNameLevel2: "",
        TypeNameLevel3: "",
        AvailableQuantityStart: null,
        AvailableQuantityEnd: null,
        ExistQuantityStart: null,
        ExistQuantityEnd: null,
        StoreId: null,
        AttributeName: "",
        WhId: null,
        TypeplatformIdChain: "",
        TypeIdChain: "",
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      busiList: [],
      whList: [],
      TypePlatforms: [],
      Types: [],
      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  mounted() {
    this.init();
    this.api3.list({}).then((res) => {
      if (res.Code == 0) this.whList = res.Data;
    });

    this.typePlatform_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.TypePlatforms = this.$commonJs.toTreeData(
          res.Data,
          "RecordId",
          "TypeIdParent",
          "children"
        );
      }
    });
    this.type_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Types = this.$commonJs.toTreeData(
          res.Data,
          "RecordId",
          "TypeIdParent",
          "children"
        );
      }
    });
  },
  methods: {
    onTreeSelect(t) {
      console.log(t, "yt");
      if (!t) {
        this.params.TypeplatformIdChain = null;
      } else {
        this.params.TypeplatformIdChain = t.IdChain;
      }
      console.log(this.params);
    },
    onTreeSelectStore(t) {
      console.log(t, "yt");
      if (!t) {
        this.params.TypeIdChain = null;
      } else {
        this.params.TypeIdChain = t.IdChain;
      }
      console.log(this.params);
    },
    init() {
      this.api2.list({ Status: 1, CheckState: 2 }).then((res) => {
        // console.log(res.Data);
        this.busiList = res.Data;
      });
    },
    onChange(val) {
      this.api3.list({ StoreId: val }).then((res) => {
        if (res.Code == 0) this.whList = res.Data;
      });
      this.params.StoreId = val;

      console.log(val, "aa");
    },

    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        resolve({ Count: 0, Data: [] });
      });
    },
    onExport() {
      this.api.export(this.params);
    },
  },
};
</script>
<style lang="scss">
// ----------修改elementui表格的默认样式-----------
// .el-table__body-wrapper {
//   &::-webkit-scrollbar {
//     // 整个滚动条
//     width: 0; // 纵向滚动条的宽度
//     background: rgba(213, 215, 220, 0.3);
//     border: none;
//   }
//   &::-webkit-scrollbar-track {
//     // 滚动条轨道
//     border: none;
//   }
// }
// --------------------隐藏table gutter列和内容区右侧的空白 start
// .el-table th.gutter {
//   display: none;
//   width: 0;
// }
// .el-table colgroup col[name="gutter"] {
//   display: none;
//   width: 0;
// }
// .el-table__body {
//   width: 100% !important;
// }
</style>